/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const graphMutationEditNodeContentTypeClientIdMax = 36;

export const graphMutationEditNodeContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationEditNodeTypeDescriptionMax = 2000;

export const GraphMutationEditNode = zod.object({
  contentTypeClientId: zod
    .string()
    .min(1)
    .max(graphMutationEditNodeContentTypeClientIdMax)
    .regex(graphMutationEditNodeContentTypeClientIdRegExp)
    .optional()
    .describe(
      'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
    ),
  contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  contentUuid: zod.uuid().describe('UUID v4 identifier'),
  occurredAt: zod.string().optional(),
  subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
  typeDescription: zod.string().min(1).max(graphMutationEditNodeTypeDescriptionMax).optional(),
  typeName: zod.string().min(1).optional(),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
  variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
});

export type GraphMutationEditNode = zod.input<typeof GraphMutationEditNode>;
export type GraphMutationEditNodeOutput = zod.output<typeof GraphMutationEditNode>;
